import { match } from 'ts-pattern';
import { RecommendedMobilityTypeDto, SpaciousTypeDto, ToiletLocationTypeDto, UserMobilityToolDto, } from '@/generated-sources/openapi';
export const MOBILITY_TOOL_LABELS = {
    [UserMobilityToolDto.ManualWheelchair]: '수동휠체어',
    [UserMobilityToolDto.ElectricWheelchair]: '전동휠체어',
    [UserMobilityToolDto.ManualAndElectricWheelchair]: '수전동휠체어',
    [UserMobilityToolDto.WalkingAssistanceDevice]: '보행보조도구',
    [UserMobilityToolDto.ProstheticFoot]: '의족',
    [UserMobilityToolDto.Stroller]: '유아차 동반',
    [UserMobilityToolDto.None]: '해당없음',
    [UserMobilityToolDto.Scooter]: '전동스쿠터(의료용)',
    [UserMobilityToolDto.FriendOfWheelchairUser]: '휠체어 사용자의 가족 · 친구 · 동료',
    [UserMobilityToolDto.Cane]: '지팡이',
    [UserMobilityToolDto.WalkerAndWalkingCart]: '워커 · 보행차',
    [UserMobilityToolDto.Crutch]: '목발',
    [UserMobilityToolDto.FriendOfWalkingAidUser]: '보행 보조 기기 사용자의 가족 · 친구 · 동료',
    [UserMobilityToolDto.WalkingDifficulty]: '보행 대체 · 보조 기기가 없으나 보행 불편',
};
export const MOBILITY_TOOL_OPTIONS = Object.entries(MOBILITY_TOOL_LABELS)
    .map(([value, label]) => ({
    value: value,
    label,
}))
    // '해당없음'(NONE)은 라벨 목록 순서가 바뀌어도 항상 마지막에 오도록 한다. (Array.sort는 stable이라 나머지 순서는 유지)
    .sort((a, b) => (a.value === UserMobilityToolDto.None ? 1 : 0) -
    (b.value === UserMobilityToolDto.None ? 1 : 0));
export function getMobilityToolDefaultValue(mobilityTools) {
    const validOrder = Object.keys(MOBILITY_TOOL_LABELS);
    return validOrder.find(tool => mobilityTools === null || mobilityTools === void 0 ? void 0 : mobilityTools.includes(tool));
}
export const RECOMMEND_MOBILITY_TOOL_LABELS = {
    [RecommendedMobilityTypeDto.ManualWheelchair]: '수동휠체어',
    [RecommendedMobilityTypeDto.ElectricWheelchair]: '전동휠체어',
    [RecommendedMobilityTypeDto.Elderly]: '고령자',
    [RecommendedMobilityTypeDto.Stroller]: '유아차 동반',
    [RecommendedMobilityTypeDto.NotSure]: '모름',
    [RecommendedMobilityTypeDto.None]: '추천안함',
};
export const SPACIOUS_LABELS = {
    [SpaciousTypeDto.Wide]: '🥰 매우 넓어 이용하기 아주 편리해요',
    [SpaciousTypeDto.Enough]: '😀 대부분 구역에서 문제없이 이용할 수 있어요',
    [SpaciousTypeDto.Limited]: '🙂 일부 구역만 이용할 수 있어요',
    [SpaciousTypeDto.Tight]: '🥲 매우 좁아 내부 이동이 거의 불가능해요',
};
export const SPACIOUS_OPTIONS = Object.entries(SPACIOUS_LABELS).map(([value, label]) => ({
    value: value,
    label,
}));
export const RECOMMEND_MOBILITY_TOOL_OPTIONS = Object.entries(RECOMMEND_MOBILITY_TOOL_LABELS).map(([value, label]) => ({
    value: value,
    label,
}));
export const makeRecommendedMobilityOptions = (currentOptions) => {
    const isNoneSelected = currentOptions.includes(RecommendedMobilityTypeDto.None);
    const isNotSureSelected = currentOptions.includes(RecommendedMobilityTypeDto.NotSure);
    const isAnyOtherSelected = currentOptions.length > 0 &&
        currentOptions.some(opt => opt !== RecommendedMobilityTypeDto.None &&
            opt !== RecommendedMobilityTypeDto.NotSure);
    return Object.entries(RECOMMEND_MOBILITY_TOOL_LABELS).map(([key, label]) => {
        const value = key;
        const isNone = value === RecommendedMobilityTypeDto.None;
        const isNotSure = value === RecommendedMobilityTypeDto.NotSure;
        return {
            label,
            value,
            disabled: match({
                isNoneSelected,
                isNotSureSelected,
                isAnyOtherSelected,
            })
                .with({ isNoneSelected: true }, () => !isNone)
                .with({ isNotSureSelected: true }, () => !isNotSure)
                .with({ isAnyOtherSelected: true }, () => isNone || isNotSure)
                .otherwise(() => false),
        };
    });
};
export const TOILET_SECTION_TITLE = '장애인 화장실 정보';
export const TOILET_PHOTO_GUIDE = '장애인 화장실 입구와 내부를 촬영해 주세요';
export const TOILET_LOCATION_COMMENT_PLACEHOLDER = '화장실 위치를 설명해 주세요 (예: 1층 엘리베이터 옆)';
export const TOILET_COMMENT_PLACEHOLDER = '기타 참고사항을 입력해 주세요';
export const TOILET_LOCATION_TYPE_LABELS = {
    [ToiletLocationTypeDto.Place]: '매장 내부에 있음',
    [ToiletLocationTypeDto.Building]: '건물 내 있음',
    [ToiletLocationTypeDto.None]: '없음',
    [ToiletLocationTypeDto.Etc]: '기타',
};
export const TOILET_LOCATION_TYPE_OPTIONS = Object.entries(TOILET_LOCATION_TYPE_LABELS).map(([value, label]) => ({
    value: value,
    label,
}));
export const DOOR_TYPE_LABELS = {
    Sliding: '미닫이문(옆으로 미는 슬라이딩 문)',
    Hinged: '여닫이문(앞/뒤로 여는 문)',
    Automatic: '자동문(버튼)',
    ETC: '기타',
};
export const DOOR_TYPE_OPTIONS = Object.entries(DOOR_TYPE_LABELS).map(([value, label]) => ({
    value: value,
    label,
}));
